import { CheckCircle2, X } from "lucide-react";

interface Props {
  isOpen: boolean;
  officer: any;
  onClose: () => void;
}

export default function OfficerCreatedSuccessModal({
  isOpen,
  officer,
  onClose,
}: Props) {
  if (!isOpen || !officer) return null;

  const role = officer.role;

  const roleConfig =
    role === "Controller"
      ? {
          color: "text-purple-700",
          badge: "bg-purple-100 text-purple-700",
          button: "bg-purple-600 hover:bg-purple-700",
          iconBg: "bg-purple-50",
        }
      : role === "Judge"
        ? {
            color: "text-blue-700",
            badge: "bg-blue-100 text-blue-700",
            button: "bg-blue-600 hover:bg-blue-700",
            iconBg: "bg-blue-50",
          }
        : {
            color: "text-green-700",
            badge: "bg-green-100 text-green-700",
            button: "bg-green-600 hover:bg-green-700",
            iconBg: "bg-green-50",
          };

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-[560px] overflow-hidden rounded-3xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b px-6 py-5">
          <div className="flex items-center gap-4">
            <div
              className={`flex h-14 w-14 items-center justify-center rounded-full ${roleConfig.iconBg}`}
            >
              <CheckCircle2 className={roleConfig.color} size={32} />
            </div>

            <h2 className="text-2xl font-bold">Officer Created Successfully</h2>
          </div>

          <button onClick={onClose}>
            <X />
          </button>
        </div>

        <div className="p-6">
          <p className="text-slate-600">
            The account for
            <span className="font-bold">
              {" "}
              {officer.firstName} {officer.lastName}
            </span>{" "}
            has been created.
          </p>

          <p className="mt-2 text-slate-600">
            Welcome email sent to
            <span className="font-bold"> {officer.email}</span>
          </p>

          <div className="mt-6 grid grid-cols-2 gap-4">
            <div className="rounded-xl border p-4">
              <div className="text-xs text-slate-400">USERNAME</div>

              <div
                className="mt-1 max-w-full truncate text-lg font-semibold"
                title={officer.username}
              >
                {officer.username}
              </div>
            </div>

            <div className="rounded-xl border p-4">
              <div className="text-xs text-slate-400">ROLE</div>

              <span
                className={`mt-2 inline-flex rounded-full px-3 py-1 text-sm font-semibold ${roleConfig.badge}`}
              >
                {officer.role}
              </span>
            </div>

            <div className="rounded-xl border p-4">
              <div className="text-xs text-slate-400">COURT TYPE</div>

              <div className="mt-1 text-lg font-semibold">
                {officer.courtType === "district_courts"
                  ? "District Court"
                  : "High Court"}
              </div>
            </div>

            <div className="rounded-xl border p-4">
              <div className="text-xs text-slate-400">STATUS</div>

              <div className="mt-1 text-lg font-semibold text-green-600">
                {officer.status}
              </div>
            </div>
          </div>

          <p className="mt-6 text-sm text-slate-500">
            The user will be prompted to set their own password on first login.
          </p>

          <button
            onClick={onClose}
            className={`mt-6 h-12 w-full rounded-xl text-white font-semibold ${roleConfig.button}`}
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
